import React from 'react';
import { ListGroup } from 'react-bootstrap';
import PropTypes from 'prop-types';

function Description({ children }) {
    return(
        <ListGroup>
            { children.split(/\r\n|\r|\n/).map((description, index) => {
                return (
                    <ListGroup.Item key={index}>
                        { description }
                    </ListGroup.Item>
                )
            }) }
        </ListGroup>
    )
}

Description.propTypes = {
    children: PropTypes.string
} 

export default Description;